import { FC } from 'react'

import styled from 'styled-components'

const getRiskLevelValue = (riskLevel: RiskLevelType): { label: string; color: string } => {
  switch (riskLevel) {
    case 'Unknown':
      return { label: 'Unknown', color: '#B63C3C' }
    case 'Low':
      return { label: 'Low', color: '#45D5B4' }
    case 'Acknowledged Medium':
      return { label: 'Acknowledged Medium', color: '#B63C3C' }
    case 'Medium':
      return { label: 'Medium', color: '#B63C3C' }
    case 'Acknowledged High':
      return { label: 'Acknowledged High', color: '#FA5252' }
    case 'High':
      return { label: 'High', color: '#FA5252' }
    default:
      return { label: 'Unknown', color: '#B63C3C' }
  }
}

const RiskLevelSpan = styled.span`
  font-weight: bold;
`

export type RiskLevelType = 'Unknown' | 'Low' | 'Acknowledged Medium' | 'Medium' | 'Acknowledged High' | 'High'

interface Props {
  riskLevel: RiskLevelType
}

export const RiskLevel: FC<Props> = ({ riskLevel }) => {
  if (!riskLevel) {
    return null
  }

  const { color, label } = getRiskLevelValue(riskLevel)

  return <RiskLevelSpan style={{ color: color }}>{label}</RiskLevelSpan>
}
